export class BdLRUCacheNode {

  public prev: BdLRUCacheNode;
  public next: BdLRUCacheNode;

  constructor(
    public key: string,
    public value: unknown
  ) {
  }
}
